import "./AboutContentStyles.css"

import React from 'react'
import { Link } from "react-router-dom"
import React1 from "../assets/test4.jpg"
import React2 from "../assets/encryption.jpg"
import React3 from "../assets/cssa.png"
import { NavLink } from "react-router-dom";

const AboutContent = () => {
  return (
    <div className="about">
      <div className="left">
        <div className="left-text">
          <h1>big ideas</h1>
          <p></p>
          <hr></hr>
          <p>PRESENT - </p>
          <p>Master of Applied Science (MASc) candidate @ <a href="https://dkundur.comm.utoronto.ca/" target="_blank" rel="noopener noreferrer"> Kundur Research Group</a></p>
          <p>Researching XAI for industrial & safety-critical infrastructure.</p>
          <p>VP Finance @ <a href="https://gradswe.sa.utoronto.ca" target="_blank" rel="noopener noreferrer"> u of t grad society of women engineers (swe)</a></p>
          <hr></hr>
          <p>2024-25</p>
          <p>
            Graduated BASc in Computer Engineering (u of t). </p> <p> double minor in artificial intelligence engineering + robotics and mechatronics. </p><p>certificate(s) in business + electric vehicle design. </p>

          <p>former co-president @ <a href="https://www.instagram.com/uoftcssa/" target="_blank" rel="noopener noreferrer">u of t cybersecurity association</a></p>

          <p>former VP Finance @ <a href="https://www.utra.ca/about" target="_blank" rel="noopener noreferrer">u of t's largest robotics association (UTRA) </a></p>
          <hr></hr>
          <p>2023-24</p> <p>former finance director @ <a href="https://utek.skule.ca/" target="_blank" rel="noopener noreferrer">u of t's flagship engineering competition (UTEK) </a></p>
          <hr></hr>
          <p>ALWAYS</p>
          <p>love doing hackathons with friends & sharing my passion for engineering</p>
          <p></p>
        </div>
        <div className="pro-btns">
          <NavLink to="https://engineeringcareers.utoronto.ca/pey-co-op-edge-conference-2023/speakers/" className="btn">Panels</NavLink>
          <NavLink to="https://devpost.com/software/ferrofetcher" className="btn">Hackathons</NavLink>

        </div>

      </div>

      <div className="right">
        <div className="img-vertical">
          <img src={React3} className="img" alt="React3" />
          <img src={React1} className="img" alt="React1" />
          <img src={React2} className="img" alt="React2" />
          {/* Add more images below as needed */}
          {/* <img src={React1} className="img" alt="React1-duplicate" />
          <img src={React2} className="img" alt="React2-duplicate" /> */}
        </div>
      </div>


    </div >
  )
}

export default AboutContent